import { render, staticRenderFns } from "./AddressUpdate.vue?vue&type=template&id=736b2ce9&"
import script from "./AddressUpdate.vue?vue&type=script&lang=js&"
export * from "./AddressUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports